import { InferRequestType, InferResponseType } from "hono";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { client } from "@/lib/hono";
import toast from "@/lib/toast";
import { t } from "@/lib/localization";

export type CreateVideoAvatarRequest = InferRequestType<
    (typeof client.api.avatars.heygen.avatars.video)["$post"]
>["json"];
export type CreateVideoAvatarResponse = InferResponseType<
    (typeof client.api.avatars.heygen.avatars.video)["$post"],
    200
>;

export const useCreateVideoAvatar = () => {
    const qc = useQueryClient();
    return useMutation<CreateVideoAvatarResponse, Error, CreateVideoAvatarRequest>(
        {
            mutationKey: ["createVideoAvatar"],
            mutationFn: async (json) => {
                const response = await client.api.avatars.heygen.avatars.video.$post({ json });
                if (!response.ok)
                    throw new Error("Failed to create digital-twin avatar");
                return await response.json();
            },
            onSuccess: () => {
                toast.success(t("avatars.toast.create-video.success"), {
                    keyName: "avatars.toast.create-video.success",
                });
                qc.invalidateQueries({ queryKey: ["avatars"] });
            },
            onError: () => {
                toast.error(t("avatars.toast.create-video.error"), {
                    keyName: "avatars.toast.create-video.error",
                });
            },
        }
    );
};
